import Api from '../../api'
import { call, put, takeEvery, select } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from '../create-request-saga'
import { intersectionWith, isEqual } from 'lodash'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import { addCustomContent } from 'portal-modules/common/redux/modules/customContent'
import { PAYMENT_TYPES } from 'portal-modules/payments/constants/types'

// action types
export const REQUEST_AVAILABLE_PAYMENT_TYPES =
  'rp/bulkAvailablePaymentTypes/REQUEST_AVAILABLE_PAYMENT_TYPES'
export const RECEIVE_AVAILABLE_PAYMENT_TYPES =
  'rp/bulkAvailablePaymentTypes/RECEIVE_AVAILABLE_PAYMENT_TYPES'
const REQUEST_BULK_PAYMENT_SETTINGS =
  'rp/bulkAvailablePaymentTypes/REQUEST_BULK_PAYMENT_SETTINGS'
const RESET_AVAILABLE_PAYMENT_TYPES =
  'rp/bulkAvailablePaymentTypes/RESET_AVAILABLE_PAYMENT_TYPES'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_AVAILABLE_PAYMENT_TYPES:
      return { ...payload }
    case RESET_AVAILABLE_PAYMENT_TYPES:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestAvailablePaymentTypes = callback => ({
  type: REQUEST_AVAILABLE_PAYMENT_TYPES,
  callback,
})

export const receiveAvailablePaymentTypes = payload => ({
  type: RECEIVE_AVAILABLE_PAYMENT_TYPES,
  payload,
})

export const requestPaymentSettings = callback => ({
  type: REQUEST_BULK_PAYMENT_SETTINGS,
  callback,
})

export const resetAvailablePaymentTypes = callback => ({
  type: RESET_AVAILABLE_PAYMENT_TYPES,
  callback,
})

// extra functions
const setAvailPaymentTypesWithFees = (availablePaymentTypes, sumOfFees) => {
  let availablePaymentTypesWithFees = []
  if (!availablePaymentTypes || !Object.values(availablePaymentTypes).length)
    return []
  Object.values(availablePaymentTypes).forEach((row, index) => {
    availablePaymentTypesWithFees[index] = {
      id: row.id,
      name: row.name,
      max_payment_amount: row.max_payment_amount,
      require_cvv: row.require_cvv,
      fee: parseFloat(sumOfFees['fee'][row.id]).toFixed(2),
      debit_fee: parseFloat(sumOfFees['debit_fee'][row.id]).toFixed(2),
      commercial_fee: parseFloat(sumOfFees['commercial_fee'][row.id]).toFixed(
        2,
      ),
      international_fee: parseFloat(
        sumOfFees['international_fee'][row.id],
      ).toFixed(2),
      commercial_debit_fee: parseFloat(
        sumOfFees['commercial_debit_fee'][row.id],
      ).toFixed(2),
      international_debit_fee: parseFloat(
        sumOfFees['international_debit_fee'][row.id],
      ).toFixed(2),
      require_business_account: row.require_business_account,
    }
  })

  return availablePaymentTypesWithFees
}

const setAvailPaymentTypeData = (availPaymentTypes, row, index) => {
  availPaymentTypes[index] = {
    id: row.id,
    name: row.name,
    max_payment_amount: row.max_payment_amount,
    require_cvv: row.require_cvv,
    require_business_account: row.require_business_account,
  }
  return false
}

const updateConvFeeByPaymentType = (sumOfCalcFee, paymentType, keyFee) => {
  sumOfCalcFee[keyFee][paymentType.id] =
    (paymentType[keyFee] ? paymentType[keyFee] : 0) +
    (sumOfCalcFee[keyFee][paymentType.id]
      ? sumOfCalcFee[keyFee][paymentType.id]
      : 0)
}

// sagas
export function* fetchAvailablePaymentTypes({ callback }) {
  let API_AVAILABLE_PAYMENT_TYPES = Api.getAvailablePaymentTypes
  let data = {}
  let currentIndex = 1

  let tokenexSettings = []
  let worldpaySettings = []
  let updatingLeaseData = null
  let availablePaymentTypes = []
  let unavailablePaymentTypes = []
  let calculationsCompleted = false
  let tempAvailablePaymentTypes = []
  let storedAvailablePaymentTypes = {}
  let availablePaymentTypesWithFees = []

  let sumOfFees = {
    fee: [],
    debit_fee: [],
    commercial_fee: [],
    international_fee: [],
    commercial_debit_fee: [],
    international_debit_fee: [],
  }

  if (typeof callback === 'object' && callback.skip_api == false) {
    data = yield call(API_AVAILABLE_PAYMENT_TYPES, callback)
  }

  yield select(({ bulkAvailablePaymentTypes }) => {
    storedAvailablePaymentTypes = bulkAvailablePaymentTypes || {}
  })

  if (callback.skip_api == true && storedAvailablePaymentTypes) {
    //This code block is executed in case we need to update / revalidate existing store data in case of custom payment amount
    if (
      storedAvailablePaymentTypes[callback.current_lease_id] &&
      callback.bulkUpdate == false
    ) {
      updatingLeaseData = storedAvailablePaymentTypes[callback.current_lease_id]
      if (
        callback.revalidate == true &&
        callback.amount != updatingLeaseData.amount
      ) {
        updatingLeaseData = yield call(API_AVAILABLE_PAYMENT_TYPES, callback)
      }
    }
  }

  currentIndex =
    storedAvailablePaymentTypes &&
    storedAvailablePaymentTypes[`common`] &&
    storedAvailablePaymentTypes[`common`][`current_index`]
      ? storedAvailablePaymentTypes[`common`][`current_index`] + 1
      : 1
  tokenexSettings =
    storedAvailablePaymentTypes &&
    storedAvailablePaymentTypes[`common`] &&
    storedAvailablePaymentTypes[`common`][`tokenex_settings`]
      ? storedAvailablePaymentTypes[`common`][`tokenex_settings`]
      : []
  worldpaySettings =
    storedAvailablePaymentTypes &&
    storedAvailablePaymentTypes[`common`] &&
    storedAvailablePaymentTypes[`common`][`worldpay_settings`]
      ? storedAvailablePaymentTypes[`common`][`worldpay_settings`]
      : []

  if (updatingLeaseData) {
    currentIndex =
      storedAvailablePaymentTypes &&
      storedAvailablePaymentTypes[`common`] &&
      storedAvailablePaymentTypes[`common`][`current_index`]
  }
  if (
    storedAvailablePaymentTypes[`common`] &&
    storedAvailablePaymentTypes[`common`][`available_payment_types`]?.length >
      0 &&
    callback.bulkUpdate == false
  ) {
    // This code block will execute from 2nd iteration when store is having some value
    if (updatingLeaseData) {
      //In this condition we are updating existing values under lease we will just change the value for is_checked flag
      data = {
        ...updatingLeaseData,
        ['is_checked']: callback.is_checked,
      }
    } else {
      data = {
        ...data,
        ['is_checked']: callback.is_checked,
      }
    }

    data?.available?.map((row, index) =>
      setAvailPaymentTypeData(tempAvailablePaymentTypes, row, index),
    )

    //Here we are finding out the commmonly available payment types by selecting only intersecting values
    if (
      storedAvailablePaymentTypes[`common`][`available_payment_types`] &&
      !tempAvailablePaymentTypes.length
    ) {
      availablePaymentTypes =
        storedAvailablePaymentTypes[`common`][`available_payment_types`]
    } else {
      availablePaymentTypes = intersectionWith(
        tempAvailablePaymentTypes,
        storedAvailablePaymentTypes[`common`][`available_payment_types`],
        isEqual,
      )
    }
  } else if (callback.bulkUpdate == false) {
    // This is first iteration condition when store is empty
    if (updatingLeaseData) {
      data = {
        ...updatingLeaseData,
        ['is_checked']: callback.is_checked,
      }
    } else {
      data = {
        ...data,
        ['is_checked']: callback.is_checked,
      }
    }

    tokenexSettings = data.tokenex_settings
    worldpaySettings = data.worldpay_settings
    data?.available?.map((row, index) =>
      setAvailPaymentTypeData(availablePaymentTypes, row, index),
    )

    if (
      storedAvailablePaymentTypes &&
      Object.values(storedAvailablePaymentTypes).length > 1
    ) {
      Object.values(storedAvailablePaymentTypes).forEach(row => {
        if (
          !row.available_payment_types &&
          row.is_checked == true &&
          row.lease_id != callback.current_lease_id
        ) {
          if (row.available && Object.values(row.available).length) {
            row.available &&
              Object.values(row.available).map((irow, index) =>
                setAvailPaymentTypeData(tempAvailablePaymentTypes, irow, index),
              )
          } else {
            tempAvailablePaymentTypes = []
          }
        }

        if (
          availablePaymentTypes.length == 0 ||
          tempAvailablePaymentTypes.length == 0
        ) {
          if (availablePaymentTypes.length == 0) {
            availablePaymentTypes = Object.keys(tempAvailablePaymentTypes).map(
              index => tempAvailablePaymentTypes[index],
            )
          } else if (tempAvailablePaymentTypes.length == 0) {
            //
          }
        } else {
          availablePaymentTypes = intersectionWith(
            tempAvailablePaymentTypes,
            availablePaymentTypes,
            isEqual,
          )
        }
      })
    }
  }

  if (typeof callback === 'object' && callback.bulkUpdate == false) {
    data = {
      ...storedAvailablePaymentTypes,
      [`${callback.current_lease_id}`]: data,
    }
  }

  if (callback.bulkUpdate == true) {
    data = {
      ...storedAvailablePaymentTypes,
    }
    Object.keys(data).map(key => {
      data[key]['is_checked'] = callback.bulkValue
    })
    availablePaymentTypes = [...data]
  }

  if (currentIndex == callback.last_index || callback.single_call == true) {
    data &&
      Object.values(data).forEach(row => {
        if (
          row.is_checked &&
          row.unavailable &&
          Object.values(row.unavailable).length
        ) {
          Object.values(row.unavailable).forEach(paymentType => {
            unavailablePaymentTypes[paymentType.id] = paymentType
          })
        }
        if (
          row.available_payment_types ||
          !row.is_checked ||
          !row.available ||
          !Object.values(row.available).length
        ) {
          return false
        }

        Object.values(row.available).forEach(paymentType => {
          sumOfFees['fee'][paymentType.id] =
            paymentType.fee +
            (sumOfFees['fee'][paymentType.id] &&
            paymentType.id != PAYMENT_TYPES.MONEYGRAM.value
              ? sumOfFees['fee'][paymentType.id]
              : 0)
          updateConvFeeByPaymentType(sumOfFees, paymentType, 'debit_fee')

          updateConvFeeByPaymentType(sumOfFees, paymentType, 'commercial_fee')

          updateConvFeeByPaymentType(
            sumOfFees,
            paymentType,
            'international_fee',
          )

          updateConvFeeByPaymentType(
            sumOfFees,
            paymentType,
            'commercial_debit_fee',
          )

          updateConvFeeByPaymentType(
            sumOfFees,
            paymentType,
            'international_debit_fee',
          )
        })
      })

    availablePaymentTypesWithFees = setAvailPaymentTypesWithFees(
      availablePaymentTypes,
      sumOfFees,
    )
    calculationsCompleted = true
  }

  if (typeof callback === 'object') {
    data = {
      ...data,
      [`common`]: {
        [`available_payment_types`]: availablePaymentTypes,
        [`unavailable_payment_types`]:
          (Object.keys(unavailablePaymentTypes).length &&
            Object.keys(unavailablePaymentTypes).map(
              key => unavailablePaymentTypes[key],
            )) ||
          [],
        [`current_index`]: currentIndex,
        [`available_payment_types_with_fees`]: availablePaymentTypesWithFees,
        [`calculations_completed`]: calculationsCompleted,
        [`tokenex_settings`]: tokenexSettings,
        [`worldpay_settings`]: worldpaySettings,
      },
    }
  }

  localStorage.setItem('isBulkPaymentLoaded', 1)
  yield put(receiveAvailablePaymentTypes(data))
  typeof callback === 'function' && callback(data)
}

export function* fetchPaymentSettings({ callback }) {
  const {
    settings: { payments },
  } = yield select()

  const paymentSettings = payments
    ? payments
    : yield call(Api.getPaymentSettings, callback)

  yield put(
    addSettings({
      payments: { ...paymentSettings, is_duplicate_payment: false },
    }),
  )
  yield put(addCustomContent({ payments: paymentSettings.custom_text }))
}

function* watchRequestAvailablePaymentTypes() {
  yield takeEvery(
    REQUEST_AVAILABLE_PAYMENT_TYPES,
    createRequestSaga(fetchAvailablePaymentTypes, {
      key: 'bulk_one_time_payments',
      message: __('Loading Payment Methods...'),
    }),
  )
}

function* watchRequestPaymentSettings() {
  yield takeEvery(
    REQUEST_BULK_PAYMENT_SETTINGS,
    createRequestSaga(fetchPaymentSettings, {
      key: 'payments',
      messgae: __('Looking up payment settings'),
      duration: 500,
    }),
  )
}

export const sagas = [
  watchRequestAvailablePaymentTypes,
  watchRequestPaymentSettings,
]
